module.exports = __webpack_public_path__ + "46181d1469f53fd184cf3d5d8abf9b23.png";